import { DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";
import {
  formatDateYYYYMMDD,
  formatDateFromObject,
} from "@packages/shared-business";

/**
 * Angular Date Format Service
 * Wrapper around framework-agnostic date utilities
 * Maintains backward compatibility with Angular DatePipe
 */
@Injectable({
  providedIn: "root",
})
export class DateFormateService {
  constructor(private datePipe: DatePipe) {}

  /**
   * Format date to YYYY-MM-DD
   * Uses framework-agnostic utility
   */
  yearMonthDate(date: Date | string | number): string {
    return formatDateYYYYMMDD(date);
  }

  /**
   * Format date from object { year, month, day }
   * Uses framework-agnostic utility
   */
  formateDate(data: { year: number; month: number; day: number }): string {
    return formatDateFromObject(data);
  }

  /**
   * Angular DatePipe wrapper for custom formats
   * Fallback to Angular's DatePipe for complex formatting
   */
  format(date: Date | string | number, format: string): string | null {
    return this.datePipe.transform(date, format);
  }
}
